module.exports = __webpack_public_path__ + "static/media/petal2.9ea3d830.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spinners/petal2.svg
// module id = 1675
// module chunks = 46